
import React from 'react';
import PropTypes from 'prop-types';

import { MapsLinkButton } from '../../../../Maps/index';
import { joinWithSeparator, truncText } from '../../../../../utils/formater';

class Address extends React.Component {
  constructor (props) {
    super(props);

    this.item = this.props.item;
  }

  renderLocation () {
    const geoLocation = this.item.getProperty().getGeoLocation();
    const locality = geoLocation.getLocality();
    const region = geoLocation.getRegion();
    const regionDistrict = geoLocation.getRegionDistrict();
    const localityDistrict = geoLocation.getLocalityDistrict();
    const localityMicrodistrict = geoLocation.getLocalityMicrodistrict();
    const isMultiLocality = this.props.domain.get('isMultiLocality');

    return (
      <div className='full-location'>
        {
          [
            (isMultiLocality && locality && locality.name),
            (geoLocation.isSuburb() && region && region.fullName),
            (geoLocation.isSuburb()
                    ? (regionDistrict && regionDistrict.fullName)
                    : joinWithSeparator([
                      localityDistrict && localityDistrict.fullName,
                      localityMicrodistrict && localityMicrodistrict.fullName
                    ])
            )
          ].filter(Boolean).join(', ')
        }
      </div>
    );
  }

  /**
   * Жилой комплекс, Коттеджный поселок, Гаражный кооператив, Садоводческое товарищество
   * @returns {Array}
   */
  renderComplex () {
    const item = this.item;
    const complexes = [
      item.getResidentialComplex(),
      item.getCottageComplex(),
      item.getGardenAssociation(),
      item.getGarageComplex()
    ];

    return complexes
      .filter(x => x)
      .map((complex, index) => {
        return complex.getUri() ? (
          <a key={index} className='residential' href={complex.getUri()} target='_blank'>
            {complex.getLabel()}
          </a>
        ) : (
          <span key={index} className='residential'>{complex.getLabel()}</span>
        );
      }
    );
  }

  render () {
    const property = this.item.getProperty();
    const geoLocation = property.getGeoLocation();
    const distance = geoLocation.getDistanceFromCity();
    const type = property.getType();

    return (
      <div className='property__address'>
        <div className='content-container'>
          <a target='_blank' className='location slim' href={this.item.getLink()}>
            { type && (<span className='main-param'>{type.get('shortName')},&nbsp;</span>) }
            {truncText(geoLocation.getShortAddress(), 40)}
          </a>

          <MapsLinkButton realtyObject={this.item} eventMapModal={this.props.eventMapModal} />

          { this.renderLocation() }
          { this.renderComplex() }

          { distance && (<div className='distance'>{'Удаленность от города: ' + distance + ' км.'}</div>) }
        </div>
      </div>
    );
  }
}

Address.propTypes = {
  item: PropTypes.object.isRequired,
  domain: PropTypes.object.isRequired,

  eventMapModal: PropTypes.func
};

export default Address;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/FlexItems/Items/Address.jsx